import { useContext, useEffect, useState } from 'react'

import { useSearchParams } from 'react-router-dom'
import { NavBar } from "../../components/NavBar";
import { mascaraMoeda, maskCurrency } from "../../utils/utils";
import { api } from '../../api/api';
import { DateTime } from 'luxon';
import { Toast } from '../../utils/Toast';
import { IoTicketOutline } from 'react-icons/io5';
import { FiEdit2, FiPlus, FiSave } from 'react-icons/fi';
import _ from 'lodash';
import { GlobalContext } from '../../context/GlobalContext';
import '../admin.css';
import './style.css';

const DEFAULT_COUPON = {
  id: '',
  codCupom: '',
  typeDiscount: 'porcentagem',
  dateLimitUsage: '',
  pricingMin: 0,
  discount: 0,
  limitUsed: 0,
  firstPurchase: false,
  active: false
}

export function CupomPage() {
  const [searchParams] = useSearchParams()
  const editId = searchParams.get("edit")
  const { isAccess } = useContext(GlobalContext)

  const [cupons, setCupons] = useState([])
  const [listFilter, setListFilter] = useState('active')
  const [state, setState] = useState(DEFAULT_COUPON)

  async function createCupom() {
    if (!isAccess('cupons', 'create')) {
      return Toast.warning('Você não tem permissão para criar cupom')
    }

    try {
      const respone = await api.post('/cupons', state)
      Toast.success("Cupom criado com sucesso.")
      await listAllCupons()
      setState({
        ...state,
        id: respone.data.id
      })
    } catch (error) {
      const message = error?.response?.data?.message ?? 'Erro ao criar cupom'
      Toast.warning(message)
    }
  }


  async function updateCupom() {
    if (!isAccess('cupons', 'update')) {
      return Toast.warning('Você não tem permissão para atualizar cupom')
    }

    try {
      const { codCupom, ...coupon } = state
      await api.put('/cupons/' + state.id, coupon)
      Toast.success("Cupom atualizado com sucesso.")
      await listAllCupons()
    } catch (error) {
      const message = error?.response?.data?.message ?? 'Erro ao atualizar cupom'
      Toast.warning(message)
    }
  }

  async function updateStatus(id, status) {
    if (!isAccess('cupons', 'update')) {
      return Toast.warning('Você não tem permissão para atualizar cupom')
    }

    try {
      await api.put('/cupons/' + id, {
        active: status
      })
      await listAllCupons()
    } catch (error) {
      const message = error?.response?.data?.message ?? 'Erro ao atualizar cupom'
      Toast.warning(message)
    }
  }

  async function listAllCupons() {
    const response = await api.get('/cupons')
    setCupons(_.orderBy(response.data, (a) => a.codCupom, 'asc'))
  }

  async function onChange(key, valueInput = '') {
    setState({
      ...state,
      [key]: valueInput
    })
  }

  async function findById(id) {
    const response = await api.get('/cupons/' + id)
    setState({
      id: response.data.id,
      codCupom: response.data.codCupom,
      typeDiscount: response.data.typeDiscount,
      dateLimitUsage: response.data?.dateLimitUsage?.substring(0, 10),
      pricingMin: response.data.pricingMin,
      discount: response.data.discount,
      limitUsed: response.data.limitUsed,
      firstPurchase: Boolean(response.data.firstPurchase),
      active: Boolean(response.data.active)
    })
  }

  useEffect(() => {
    listAllCupons()
  }, [])

  useEffect(() => {
    if (editId) {
      setListFilter('all')
      findById(editId).catch(() => Toast.warning('Não foi possível abrir o cupom para revisão.'))
    }
  }, [editId])

  const displayedCoupons = listFilter === 'active'
    ? cupons.filter((cupom) => cupom.active === true || Number(cupom.active) === 1)
    : cupons

  return (
    <>
      <NavBar>
        <main className="admin-page coupon-page">
          <header className="admin-page-header"><div><h1>Cupons de desconto</h1><p>Crie campanhas e acompanhe o uso dos códigos promocionais</p></div><button className="admin-secondary-button" onClick={() => setState(DEFAULT_COUPON)}><FiPlus /> Novo cupom</button></header>

          <section className="admin-surface coupon-form-surface">
            <div className="admin-surface-header"><div><h2>{state.id ? `Editar ${state.codCupom}` : 'Novo cupom'}</h2><p>Defina as condições de aplicação do desconto</p></div><IoTicketOutline size={20} /></div>
            <div className="admin-form-grid coupon-form-grid">
              <label><span>Código do cupom</span><input type="text" disabled={!!state.id} value={state.codCupom} onChange={(e) => onChange('codCupom', e.target.value.toUpperCase())} placeholder="BLACKFRIDAY10" /></label>
              <label><span>Válido até</span><input type="date" value={state.dateLimitUsage} onChange={(e) => onChange('dateLimitUsage', e.target.value)} /></label>
              <label><span>Tipo de desconto</span><select value={state.typeDiscount} onChange={(e) => onChange('typeDiscount', e.target.value)}><option value="porcentagem">Porcentagem</option><option value="fixo">Valor fixo</option></select></label>
              <label><span>Valor do desconto</span><input type="number" value={state.discount} onChange={(e) => onChange('discount', e.target.value)} /></label>
              <label><span>Pedido mínimo</span><input type="text" value={maskCurrency(state.pricingMin)} onChange={(e) => onChange('pricingMin', mascaraMoeda(e.target.value))} /></label>
              <label><span>Limite de uso</span><input type="number" value={state.limitUsed} onChange={(e) => onChange('limitUsed', e.target.value)} aria-describedby="coupon-limit-help" /><small id="coupon-limit-help">Use 0 para ilimitado</small></label>
              <label className="coupon-check"><input type="checkbox" checked={state.active} onChange={(e) => onChange('active', e.target.checked)} /> Cupom ativo (desmarcado: rascunho inativo)</label>
              <label className="coupon-first-purchase"><span>Elegibilidade</span><span className="coupon-check"><input checked={state.firstPurchase} onChange={(e) => onChange('firstPurchase', e.target.checked)} type="checkbox" /> Somente primeira compra</span></label>
              <div className="coupon-form-actions"><button className="admin-primary-button" onClick={async () => {
                if (!state.id) {
                  await createCupom()
                } else {
                  await updateCupom()
                }
              }}><FiSave /> Salvar cupom</button></div>
            </div>
          </section>

          <section className="admin-surface">
            <div className="admin-surface-header"><div><h2>{listFilter === 'active' ? 'Cupons ativos' : 'Todos os cupons'}</h2><p>{displayedCoupons.length} cupons encontrados</p></div><div className="coupon-filter" role="group" aria-label="Filtrar cupons"><button className={listFilter === 'active' ? 'active' : ''} onClick={() => setListFilter('active')}>Ativos</button><button className={listFilter === 'all' ? 'active' : ''} onClick={() => setListFilter('all')}>Todos</button></div></div>
          <div className="admin-table-wrap"><table className="admin-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Código do cupom</th>
                <th >Desconto</th>
                <th>Validade</th>
                <th>Uso limite</th>
                <th>Usados</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {displayedCoupons.map((cupom) => {
                let discount = null

                if (cupom.typeDiscount === 'porcentagem') {
                  discount = `${cupom.discount}%`
                } else {
                  discount = maskCurrency(cupom.discount)
                }

                // let isValid = true

                // const currentDate = DateTime.local().startOf('day')
                // const dateLimitUsage = DateTime.fromISO(cupom.dateLimitUsage).startOf('day').toLocal()

                // if (dateLimitUsage.diff(currentDate, 'days').days < 0) {
                //   isValid = false
                // }

                // if (cupom.used === cupom.limitUsed && cupom.limitUsed !== 0) {
                //   isValid = false
                // }

                return (
                  <tr key={cupom.id}>
                    <td data-label="#">#</td>
                    <td data-label="Código"><strong>{cupom.codCupom}</strong></td>
                    <td data-label="Desconto">{discount}</td>
                    <td data-label="Validade">{cupom.dateLimitUsage ? DateTime.fromISO(cupom.dateLimitUsage).toUTC().toFormat('dd/MM/yyyy') : 'Sem data limite'}</td>
                    <td data-label="Limite">{cupom.limitUsed === 0 ? 'Ilimitado' : cupom.limitUsed}</td>
                    <td data-label="Usados">{cupom.used} usados</td>
                    <td data-label="Ações"><div className="coupon-row-actions"><label className="admin-toggle" aria-label={`${cupom.active ? 'Desativar' : 'Ativar'} cupom ${cupom.codCupom}`}><input checked={Boolean(cupom.active)} onChange={(e) => updateStatus(cupom.id, e.target.checked)} type="checkbox" /><span /></label><button className="admin-icon-button" onClick={() => findById(cupom.id)} aria-label={`Editar ${cupom.codCupom}`}><FiEdit2 /></button></div>
                    </td>
                  </tr>
                )
              })}

              {displayedCoupons.length === 0 && (
                <tr>
                  <td colSpan={7} className="text-center text-muted py-4">
                    {listFilter === 'active' ? 'Nenhum cupom ativo encontrado.' : 'Nenhum cupom encontrado.'}
                  </td>
                </tr>
              )}

            </tbody>
          </table></div>
          </section>
        </main>
      </NavBar>
    </>
  )
}
